const simplifyCurriculumName = (originalText) => {
  const parts = originalText.split(' ');
  if (parts.length >= 3) {
    // const prefix = parts[0]; // Encabezado: Malla, Plan, etc.
    const careerAbbr = parts[1].substring(0, 3); // Primeras 3 letras de la carrera
    const year = parts[2].match(/\d{4}/); // Detecta el a�o dentro del tercer elemento
    if (year) {
      // return `${prefix} ${careerAbbr} ${year[0]}`;
      return `${careerAbbr} ${year[0]}`;
    }
  }
  return `Invalid format: ${originalText}`;
};

export default simplifyCurriculumName;
